<template>
  <div class="mb-4">
    <slot></slot>
  </div>
</template>
